import $ from 'jquery';

$(document).ready(function() {
    $(document).on('click', '.js-search', function() {
        $('.b-header__search').show();
    });
    $(document).on('click', '.js-search-close', function() {
        $('.b-header__search').hide();
    });
});


// WEBPACK FOOTER //
// ./src/js/general/search.js